import { loadUserCompany, saveUserCompany } from "../../firebaseCalls";

const TRIAL_LOAD_COMPANY_REQUEST = "TRIAL_LOAD_COMPANY_REQUEST";
const TRIAL_LOAD_COMPANY_SUCCESS = "TRIAL_LOAD_COMPANY_SUCCESS";
const TRIAL_LOAD_COMPANY_ERROR = "TRIAL_LOAD_COMPANY_ERROR";

const TRIAL_SAVE_COMPANY_REQUEST = "TRIAL_SAVE_COMPANY_REQUEST";
const TRIAL_SAVE_COMPANY_SUCCESS = "TRIAL_SAVE_COMPANY_SUCCESS";
const TRIAL_SAVE_COMPANY_ERROR = "TRIAL_SAVE_COMPANY_ERROR";

export function loadCompanyAction() {
  return async (dispatch, getState) => {
    dispatch({ type: TRIAL_LOAD_COMPANY_REQUEST });
    try {
      const company = await loadUserCompany();
      dispatch({ type: TRIAL_LOAD_COMPANY_SUCCESS, company });
    } catch (e) {
      console.log(e);
      dispatch({ type: TRIAL_LOAD_COMPANY_ERROR, error: e });
    }
  };
}

export function saveCompanyAction(company) {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: TRIAL_SAVE_COMPANY_REQUEST });
      const saved = await saveUserCompany(company);
      dispatch({ type: TRIAL_SAVE_COMPANY_SUCCESS, company: saved });
    } catch (e) {
      dispatch({ type: TRIAL_SAVE_COMPANY_ERROR, error: e });
    }
  };
}

const INIT_STATE = {};

export const trialReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case TRIAL_LOAD_COMPANY_REQUEST:
      return { ...state, loading: true };
    case TRIAL_LOAD_COMPANY_SUCCESS:
      return {
        ...state,
        loading: false,
        company: action.company,
        trials: action.trials
      };
    case TRIAL_LOAD_COMPANY_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error
      };
    case TRIAL_SAVE_COMPANY_REQUEST:
      return { ...state, saving: true };
    case TRIAL_SAVE_COMPANY_SUCCESS:
      return {
        ...state,
        saving: false,
        company: action.company
      };
    case TRIAL_SAVE_COMPANY_ERROR:
      return {
        ...state,
        saving: false,
        error: action.error
      };

    default:
      return state;
  }
};

//selectors
export const isLoading = state => state.trial.loading;
export const isSaving = state => state.trial.saving;
export const getCompany = state => state.trial.company;
